import { z } from 'zod';

/** E.164: leading +, country code 1-9, 7..15 digits total. */
export const E164_REGEX = /^\+[1-9]\d{6,14}$/;

export const phoneE164Schema = z
  .string()
  .trim()
  .regex(E164_REGEX, 'Phone must be E.164, e.g. +919876543210');

/**
 * Meta's `to` field wants digits only, no plus.
 */
export function toMetaPhone(e164: string): string {
  return e164.replace(/^\+/, '');
}

/**
 * Mask for logs and for the `ops` role in the dashboard: keep country code and last 2,
 * hide the middle. `+919876543210` -> `+91 98765 ••••10`.
 */
export function maskPhone(e164: string): string {
  if (!E164_REGEX.test(e164)) return '••••';
  const digits = e164.slice(1);
  const last = digits.slice(-2);
  const head = digits.slice(0, Math.max(0, digits.length - 6));
  return `+${head}••••${last}`;
}

/** Normalise loosely-formatted input (spaces, dashes, brackets) to E.164 if possible. */
export function normalisePhone(input: string, defaultCountryCode = '91'): string | null {
  const cleaned = input.replace(/[\s\-()./]/g, '');
  if (E164_REGEX.test(cleaned)) return cleaned;
  if (/^\d{10}$/.test(cleaned)) return `+${defaultCountryCode}${cleaned}`;
  if (/^0\d{10}$/.test(cleaned)) return `+${defaultCountryCode}${cleaned.slice(1)}`;
  const withPlus = `+${cleaned.replace(/^\++/, '')}`;
  return E164_REGEX.test(withPlus) ? withPlus : null;
}
